import center from '@turf/center';
import { toBounds } from '../utils';
export const childAdministrativeLevels = {
  district: null,
  city: null,
  epci: 'city',
  department: 'epci',
  region: 'department',
  country: 'region',
  world: 'country'
};
export const administrativeLevelsValues = {
  district: 0,
  city: 1,
  epci: 2,
  department: 3,
  region: 4,
  country: 5,
  world: 6
};
export class CyclabilityZone {
  constructor(id, administrativeLevel, ref = null, countryCode = null, name = '', geometry, stats = [], statsBNSC = []) {
    this.id = id;
    this.administrativeLevel = administrativeLevel;
    this.ref = ref;
    this.countryCode = countryCode;
    this.name = name;
    this.geometry = geometry;
    this.stats = stats;
    this.statsBNSC = statsBNSC;
    if (geometry && geometry.coordinates.length > 0) {
      this.bounds = toBounds(geometry);
      this.center = center(geometry).geometry;
    } else {
      this.bounds = {
        north: 90,
        east: 180,
        south: -90,
        west: -180
      };
      this.center = {
        type: 'Point',
        coordinates: [0, 0]
      };
    }
  }
  get code() {
    const zoneCode = this.name.toLowerCase()
    // .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-').replace(/'/g, '-');
    switch (this.administrativeLevel) {
      case 'world':
        return 'world';
      case 'country':
        return this.countryCode?.toLowerCase() || '';
      case 'region':
        return zoneCode;
      case 'department':
      case 'epci':
      case 'city':
        return `${zoneCode}_${this.ref}`;
      default:
        return '';
    }
  }
}